import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AmministrazioneTrasparente } from '../../../../shared/interface';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-modifica-amministrazione-trasparente-backoffice',
  templateUrl: './modifica-amministrazione-trasparente-backoffice.component.html',
  styleUrl: './modifica-amministrazione-trasparente-backoffice.component.css'
})
export class ModificaAmministrazioneTrasparenteBackofficeComponent {

  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private confirmationService: ConfirmationService) { }
  
  categorie: { categoria: string, value: string }[] = [
    { value: 'organo_direttivo', categoria: 'Organo Direttivo'.toLocaleLowerCase() },
    { value: 'contributi_pubblici', categoria: 'Contributi Pubblici'.toLocaleLowerCase() },
    { value: 'consulenze_collaborazioni', categoria: 'Consulenze Collaborazioni'.toLocaleLowerCase() },
    { value: 'organi_amministrativi', categoria: 'Organi Amministrativi'.toLocaleLowerCase() },
  ]

  formAmministrazioneTrasparente!: FormGroup;

  filePdf: File | null = null

  file_amministrazione_trasparente?: AmministrazioneTrasparente

  ngOnInit(): void {

    this.formAmministrazioneTrasparente = new FormGroup({
      categoria: new FormControl(null, Validators.required),
      titolo: new FormControl(null, Validators.required),
      pdf: new FormControl(null, Validators.required),
    })

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getFileAmministrazioneTrasparente(id).subscribe({
        next: (data) => this.file_amministrazione_trasparente = data,
        error: (err) => this.router.navigate(['/backoffice/amministrazione-trasparente']),
        complete: () => {

          this.formAmministrazioneTrasparente.patchValue({
            categoria: { categoria: this.file_amministrazione_trasparente?.categoria.replace('_', ' ').toLowerCase(), value: this.file_amministrazione_trasparente?.categoria },
            titolo: this.file_amministrazione_trasparente?.titolo,
            pdf: this.file_amministrazione_trasparente?.pdf
          })

        }
      })


    })
  }

  onDeletePopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il file dell'amministrazione trasparente?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteFileAmministrazioneTrasparente(this.file_amministrazione_trasparente!.id).subscribe({
          next: (data) => this.apiService.setUtenti(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/amministrazione-trasparente']);
            this.apiService.message("success", "Eliminazione", "L'utente è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onPDFUpload(file: any) {
    const pdf = file.currentFiles[0];
    this.filePdf = pdf;
    this.formAmministrazioneTrasparente.patchValue({ pdf: pdf.name });
  };

  onRemovePDFUpload(file: any) {
    this.filePdf = null
    this.formAmministrazioneTrasparente.patchValue({ pdf: '' });
  }

  onSubmit() {

    const formData = new FormData();    
    formData.append('pdf', this.filePdf || '');
    formData.append('titolo', this.formAmministrazioneTrasparente.get('titolo')?.value);
    formData.append('categoria', this.formAmministrazioneTrasparente.get('categoria')?.value.value);

    this.apiService.updateFileAmministrazioneTrasparente(formData, this.file_amministrazione_trasparente!.id).subscribe({
      next: (data) => this.apiService.setFilesAmministrazioneTrasparente(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/amministrazione-trasparente'])
        this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
      }
    })

  }


}
